import { render, staticRenderFns } from "./FullOverlay.vue?vue&type=template&id=306d4cf2&lang=pug&"
import script from "./FullOverlay.vue?vue&type=script&lang=js&"
export * from "./FullOverlay.vue?vue&type=script&lang=js&"
import style0 from "./FullOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306d4cf2')) {
      api.createRecord('306d4cf2', component.options)
    } else {
      api.reload('306d4cf2', component.options)
    }
    module.hot.accept("./FullOverlay.vue?vue&type=template&id=306d4cf2&lang=pug&", function () {
      api.rerender('306d4cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/FullOverlay.vue"
export default component.exports